module.exports = __webpack_public_path__ + "static/media/medication.105ba2ac.jpg";